<template>
  <div class="answer-setting">
    <!-- 填写设置 -->
    <ItemContainer title="填写设置" subTitle="（仅限网络调查生效）">
      <div class="mb-3">
        <span class="item-label mr-6"
          >答题过程中可回退
          <span class="text-small text-theme-black-450">（答卷者能够返回上一页更改答案）</span>
        </span>
        <el-switch v-model="pageFlag" @change="handlerPageFlag($event, 'enablePrePage')"></el-switch>
      </div>

      <div class="mb-3">
        <span class="item-label">
          {{ fillSetting.open.text }}
          <el-tooltip
            class="item"
            effect="light"
            placement="top"
          >
            <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-medium ml-0.5 mr-6"></i>
            <template v-slot:content>
              <div class="text-center">
                <div class="mb-2">{{ fillSetting.open.tip }}</div>
                <img src="~@/assets/img/verification.gif" alt="">
              </div>
            </template>
          </el-tooltip>
        </span>
        <el-switch v-model="intelligentFlag" @change="handlerPageFlag($event, 'enableVerification')"></el-switch>
      </div>

      <div class="mb-3">
        <span class="item-label mr-6"> 显示【开始答题】页，用户点击【开始答题】后开始答题 </span>
        <el-switch v-model="startFlag" @change="handlerPageFlag($event, 'enableHomePage')"></el-switch>
      </div>
      <div class="mb-3">
        <span class="item-label mr-6"> 只能通过微信回答</span>
        <el-switch v-model="isOnlyWeixin" @change="handlerPageFlag($event, 'isOnlyWeixin')"></el-switch>
      </div>
      <div class="mb-3">
        <span class="item-label mr-6">
          评分题回答过程中显示答案
          <el-tooltip effect="light" content="题目开启答案与分值后生效">
            <span class="text-theme-black-350 cursor-pointer">
              <i class="iconfont icon-shuoming text-theme-black-350"></i>
            </span>
          </el-tooltip>
        </span>
        <el-switch v-model="showAnswerScoreInAnswering" @change="onChangeShowAnswerScoreInAnswering"></el-switch>
      </div>
      <div class="mb-3">
        <span class="item-label mr-6">
          答题进度条
        </span>
        <el-radio-group v-model="progressStatus" @change="onChangeProgressStatus">
          <el-radio :label="0">
            <span>隐藏</span>
          </el-radio>
          <el-radio :label="1">
            <span>显示，按已答题目数量
             <el-tooltip effect="light" content="答题进度 = 已答题目数量 ÷ 需回答题目总数量">
              <span class="text-theme-black-350 cursor-pointer">
                <i class="icon-shuoming text-theme-black-350"></i>
              </span>
             </el-tooltip>
            </span>
          </el-radio>
<!--          <el-radio :label="2">-->
<!--            <span>显示，按已答题目页数-->
<!--            <el-tooltip effect="light" content="答题进度 = 已答题目页数 ÷ 需回答题目总页数">-->
<!--              <span class="text-theme-black-350 cursor-pointer">-->
<!--                <i class="icon-shuoming text-theme-black-350"></i>-->
<!--              </span>-->
<!--             </el-tooltip>-->
<!--            </span>-->
<!--          </el-radio>-->
        </el-radio-group>
      </div>
        <div>
        <span class="item-label mr-6">
           禁止微信右上角分享
            <el-tooltip
                    effect="light"
                    content="答题者在微信中打开此答题链接后，无法分享给好友、分享到朋友圈、或通过其他方式打开。"
            >
            <span class="text-theme-black-350 cursor-pointer">
              <i class="iconfont icon-shuoming text-theme-black-350"></i>
            </span>
          </el-tooltip>
        </span>
            <el-switch v-model="disabledWxOperate" @change="onChangeWxOperate"></el-switch>
        </div>
    </ItemContainer>

    <!-- 问卷开启/关闭 -->
    <!-- <ItemContainer :title="'问卷开启/关闭'">
      <div>
        <span class="text-medium font-normal leading-22 text-theme-black-850 mr-3">全部回收渠道</span>
        <el-switch v-model="allChannelFlag" @change="changeAllChannel"></el-switch>
      </div>
      // 子渠道部分
      <div class="text-medium font-normal leading-22 text-theme-black-850 mr-3 mt-4">渠道来源</div>

      // 表格
      <el-table
        :data="tableData"
        row-key="channelName"
        :indent="3"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column prop="index" label="序号" width="60" type=""> </el-table-column>
        <el-table-column prop="channelName" label="回收渠道" width="180"> </el-table-column>
        <el-table-column prop="linkUrl" label="链接地址">
          <template slot-scope="linkUrl">
            <a
              :href="linkUrl.row.linkUrl"
              target="_blank"
              class="text-theme text-medium whitespace-nowrap overflow-hidden overflow-ellipsis"
              >{{ linkUrl.row.linkUrl }}</a
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="operate">
            <el-switch v-model="operate.row.activeFlag" @change="handleTableFlag($event, operate.row)"></el-switch>
          </template>
        </el-table-column>
      </el-table>
    </ItemContainer> -->

    <!-- 答卷编号设置 -->
    <ItemContainer :title="'答卷编号设置'">
      <div>
        <span class="text-medium font-normal leading-22 text-theme-black-850 mr-6">启用答卷编号</span>
        <el-switch v-model="numFlag" @change="handlerNumFlag"></el-switch>
      </div>
      <template v-slot:icon>
        <el-tooltip class="item" effect="light" content="系统根据预设规则自动生成答卷编号" placement="right">
          <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-1"></i>
        </el-tooltip>
      </template>
      <p class="text-small font-normal leading-22 text-yellow-theme mt-0.5 mb-2">
        <i class="el-icon-warning-outline text-medium leading-22"></i>
        答卷编号设置，仅对新回收答卷生效
      </p>
      <div class="mb-5 bg-card-bg-gray" v-show="numFlag">
        <p class="pt-3 pl-4 pb-2 text-medium font-normal leading-22 text-theme-black-850">设置答卷编号规则</p>

        <div class="serial-container" v-if="numFlag">
          <draggable :value="showComponents" handle=".serial-move" @input="changePos" animation="300">
            <transition-group tag="div" name="flip-list" class="serial-box">
              <div class="serial-item flex ml-4 mb-4" v-for="c in showComponents" :key="c.key" ref="rows">
                <component
                  :is="c.name"
                  :rule="c.rule"
                  :default-value="c.defaultValue"
                  :content="c"
                  class="flex items-center"
                  @format-change="formatChange($event, c)"
                  @check-value="checkValue($event, c)"
                  @set-defaultValue="setDefaultValue"
                  ref="rules"
                />
                <i class="el-icon-rank text-icon-default leading-10 serial-move font-semibold"></i>
              </div>
            </transition-group>
          </draggable>

          <div class="serial-view ml-4 mb-4">
            <span class="text-theme-black-650 text-medium">流水编号预览：</span>
            <span class="text-theme">{{ formatValue }}</span>
          </div>

          <div class="ml-4 pb-3">
            <el-button @click="save" type="primary" :disabled="isError" size="small" class="normal-button">保存 </el-button>
          </div>
        </div>
      </div>
    </ItemContainer>
    <!-- 随机抽题 -->
    <RandomQuestion />
    <!-- 答卷审核 -->
    <ItemContainer :title="'答卷审核'">
      <AnswerReview
        :preWj="preWj"
        :peopleExa="peopleExamine"
        :auditRa="auditRadio"
        :deadlineR="deadlineRed"
        :deadlineA="deadlineAll"
      />
    </ItemContainer>
  </div>
</template>

<script>
import ItemContainer from '@/components/base/ItemContainer.vue'
import RandomQuestion from '@/views/survey/settings/components/random-question/index.vue'
import { saveSurveySetting, getFreeLink, changeLinkUrlState } from '@/api/wenjuan/publish.js'
import { preWj, selectSerialNumberRules, closeAllWj, getSubShortLink, getSurveyPreview } from '@/api/wenjuan/wjquestion.js'
import GlobalConfig from '@/global/config.js'
import draggable from 'vuedraggable'
import ruleComponents from './components/rules'
import { setSerialNumberRules } from '@/api/wenjuan/changeSurvey.js'
import { getAnswerUrl } from '@/assets/js/utils.js'
import { SURVEY_PUBLISH_STATUS } from '@/global/config-variable.js'
import AnswerReview from './AnswerReview'
import { fillSetting } from '@/global/config-variable'

export default {
  name: 'AnswerSetting',
  components: { ItemContainer, draggable, ...ruleComponents, AnswerReview, RandomQuestion },
  props: {},
  data() {
    return {
      fillSetting,
      versionId: '',
      survey: {
        id: '',
        otherSetting: {}
      },
      key: 0,
      serialRules: [
        {
          label: '提交时间',
          command: 'submit-time',
          rule: 0
        },
        {
          label: '自增序号',
          command: 'auto-number',
          rule: 1
        },
        {
          label: '固定字符',
          command: 'fixed-char',
          rule: 2
        }
        // {
        //   label: '插入题目答案',
        //   command: 'insert-answer',
        //   rule: 3
        // }
      ],
      showComponents: [],
      tableData: [
        {
          index: 1,
          channelName: '链接&二维码',
          linkUrl: '',
          children: []
        }
      ],
      pageFlag: false, // 填写设置部分 - 返回上一页开关
      peopleExamine: false, // 答卷审核部分 - 人工审核开关
      numFlag: false, // 答卷编号部分开关
      allChannelFlag: true, // 问卷开启/关闭部分 - 总开关
      intelligentFlag: false, // 智能验证开关
      startFlag: false, // 开始答题开关
      isOnlyWeixin: false, // 是否仅微信答题
      showAnswerScoreInAnswering: 0, //回答后显示答案
      disabledWxOperate: false, // 禁止微信右上角操作
      ManualReviewFlag: false, // 人工审核开关
      auditRadio: '',
      deadlineRed: 2,
      deadlineAll: 2,
      progressStatus:null,// 进度条状态
    }
  },
  methods: {
    getParams(v, n) {
      let params = {
        id: this.survey.id,
        otherSetting: {}
      }
      params.otherSetting[n] = v
      return params
    },
    onChangeShowAnswerScoreInAnswering(val) {
      this.handlerPageFlag(Number(val), 'showAnswerScoreInAnswering')
    },
    onChangeProgressStatus(){
      this.handlerPageFlag(this.progressStatus,'progressStatus')
    },
    onChangeWxOperate(){
      this.handlerPageFlag(this.disabledWxOperate,'disabledWxOperate')
    },
    // 填写设置-第一部分
    handlerPageFlag(v, n) {
      let obj = this.getParams(v, n)
      saveSurveySetting(obj)
        .then(res => {
          this.$message.success('保存成功!')
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    // 问卷开启/关闭-第二部分
    // 总开关
    changeAllChannel(state) {
      if (state) {
        // 开启状态 - 目前没有打开的接口 - 最好能提供一个统一的控制全部链接开关的接口
        for (let i = 0; i < this.tableData.length; i++) {
          this.handleTableFlag(state, this.tableData[i])
        }
      } else {
        // 关闭状态
        closeAllWj([this.survey.id])
          .then(res => {
            this.$message.success('问卷关闭成功!')
          })
          .catch(e => {
            this.$message.error(e.message)
          })
      }
      this._getLink()
    },
    // 表格开关
    handleTableFlag(state, val) {
      if (val.children) {
        // 控制父节点 - 目前在遍历控制子链接的状态 - 希望有一个统一控制每一类问卷状态的开关
        val.children.forEach(item => {
          changeLinkUrlState({ activeFlag: Number(state), id: item.id })
        })
      } else {
        // 控制子节点
        changeLinkUrlState({ activeFlag: Number(state), id: val.id })
      }
      // 与总开关的联动
      this.connectWithAllFlag(state, val)
      this._getLink()
    },
    // 与总开关的联动
    connectWithAllFlag(state, val) {
      if (val.children) {
        // 传入父节点时触发 - 根据表格数据（val）的children属性触发
        let allFlag = this.tableData.every(item => {
          return item.activeFlag === state
        })
        if (allFlag) this.allChannelFlag = state
      } else {
        // 传入子节点时触发
        let allFlag = true
        this.tableData.forEach(item => {
          allFlag = item.children.every(v => {
            return v.activeFlag === state
          })
        })
        if (allFlag || state) this.allChannelFlag = state
      }
    },
    // 获取链接的方法 - 获取0和1的部分，然后拼接起来，希望有一个统一的获取接口
    _getLink() {
      //todo 目前只能控制 链接&二维码 的状态
      let params = {
        channelType: '1',
        surveyId: this.survey.id
      }
      this.getForm(params)
    },
    // 获取链接的方法 - 获取表格数据
    getForm(params) {
      getFreeLink(params).then(res => {
        params.channelType = '0'
        getFreeLink(params).then(val => {
          let data = val.data.data
          data = data.concat(res.data.data)
          this.handlerData(data)
        })
      })
    },
    // 获取链接的方法 - 返回问卷链接数据
    _getComputerUrl(id) {
      // return getAnswerUrl('computer', {
      return getAnswerUrl('mobile', {
        surveyId: this.survey.id,
        answerChannelId: id
      })
    },
    //获取链接的方法 - 处理数据
    handlerData(data) {
      let arr = []
      arr = arr = data.map(item => {
        return {
          id: item.id,
          surveyId: item.surveyId,
          channelName: item.channelName,
          linkUrl: this._getComputerUrl(item.id),
          activeFlag: !!item.activeFlag
        }
      })
      this.tableData[0].children = arr
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].activeFlag) {
          this.tableData[0].activeFlag = true
          break
        } else {
          this.tableData[0].activeFlag = false
        }
      }
    },
    // 答卷编号设置-第三部分
    handlerNumFlag(v) {
      this.showComponents = []
      if (v) {
        this.addEmpty()
      } else {
        this.save()
      }
    },
    checkValue(val, c) {
      c.error = !val
    },
    // 更改问卷编号
    formatChange(val, c) {
      c.formatValue = val
    },
    // 更改位置
    changePos(list) {
      this.showComponents = list
    },
    // 表单提交事件
    save() {
      let rules = new Array(this.showComponents.length)
      this.showComponents.forEach((item, index) => {
        if (item.formatValue) {
          rules[index] = { rule: item.rule, detail: item.defaultValue }
        }
      })
      let data = {
        id: this.survey.id,
        status: Number(this.numFlag),
        rules: rules.filter(Boolean),
        autoAddNumber: 0
      }
      setSerialNumberRules(data)
        .then(() => {
          this.$surveyBus.$emit('showDraft', true)
          this.$message.success('答题编号设置成功')
          this.showComponents.forEach(item => {
            if (!item.formatValue) item.checked = false
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    getKey() {
      return this.key++
    },
    // 添加数据
    addSerialRule(command, rule, defaultValue, checked) {
      this.showComponents.push({
        defaultValue,
        error: false,
        formatValue: '',
        key: this.getKey(),
        name: command,
        rule: rule,
        checked
      })
    },
    // 获取答卷编号设置的数据
    async getSerialNumberRules() {
      // 获取versionId
      await getSurveyPreview(this.survey.id).then(res => {
        this.versionId = res.data.data.versionId
      })

      selectSerialNumberRules(this.survey.id, this.versionId)
        // selectSerialNumberRules(this.survey.id)
        .then(res => {
          let data = res.data.data
          if (!data) return
          this.numFlag = Boolean(data.status)
          data.rules.forEach(r => {
            if (!r) return
            let { rule, detail } = r
            let checked = Boolean(detail)
            let s = this.serialRules.find(s => s.rule === rule)
            this.addSerialRule(s.command, s.rule, detail, checked)
          })
          // 补充数据
          this.addEmpty()
        })
    },
    // 添加空白项
    addEmpty() {
      this.serialRules.forEach((item, index) => {
        let s = this.showComponents.find(s => s.rule === index)
        if (!s) {
          this.addSerialRule(item.command, item.rule, '', false)
        }
      })
    },
    // 设置defaultValue
    setDefaultValue(name, val) {
      let s = this.showComponents.find(s => s.name === name)
      s.defaultValue = val
    },
    preWj() {
      const setComponentParams = params => {
        const { auditRadio = 'enableNetManualAudit', deadlineRed = 2, deadlineAll = 2, peopleExamine } = params
        ;[this.auditRadio, this.deadlineRed, this.deadlineAll, this.peopleExamine] = [
          auditRadio,
          deadlineRed,
          deadlineAll,
          peopleExamine
        ]
      }
      preWj(this.survey.id).then(res => {
        // 获取问卷数据
        this.survey = res.data.data
        this.pageFlag = res.data.data.otherSetting.enablePrePage
        this.intelligentFlag = res.data.data.otherSetting.enableVerification
        this.startFlag = res.data.data.otherSetting.enableHomePage
        this.isOnlyWeixin = res.data.data.otherSetting.isOnlyWeixin
        if('progressStatus' in res.data.data.otherSetting) {
          this.progressStatus = res.data.data.otherSetting.progressStatus
        }else {
          this.progressStatus = 1
        }
        this.disabledWxOperate = res.data.data.otherSetting.disabledWxOperate || false
        this.showAnswerScoreInAnswering = Boolean(res.data.data.otherSetting.showAnswerScoreInAnswering) // 0 || 1 || undefined
        // 处理开关状态及抽屉组件传参
        const otherSetting = res.data.data.otherSetting
        if (otherSetting.enableAuditForRedEnvelopes && otherSetting.enableNetManualAudit) {
          setComponentParams({
            auditRadio: 'enableAuditForRedEnvelopes',
            deadlineRed: otherSetting.auditForRedEnvelopesAutoPassTime,
            peopleExamine: true
          })
        } else if (otherSetting.enableNetManualAudit && !otherSetting.enableAuditForRedEnvelopes) {
          setComponentParams({
            deadlineAll: otherSetting.auditForRedEnvelopesAutoPassTime,
            peopleExamine: true
          })
        } else if (!otherSetting.enableNetManualAudit) {
          setComponentParams({ peopleExamine: false })
        }
        // 获取问卷开启/关闭部分的总开关的状态
        this.allChannelFlag = res.data.data.publishStatus === SURVEY_PUBLISH_STATUS.RECYCLING
      })
    }
  },
  created() {
    // 获取问卷id
    this.survey.id = GlobalConfig.getSurveyId()
    this.preWj()
    // 获取答卷编号的信息 - 答卷编号部分
    this.getSerialNumberRules()

    // 获取表格链接的数据 - 问卷开启/关闭部分
    this._getLink()
  },
  computed: {
    formatValue() {
      return this.showComponents.map(c => c.formatValue).join('')
    },
    isError() {
      return this.showComponents.some(c => c.error)
    }
  }
}
</script>
<style lang="scss" scoped>
.answer-setting {
  .item-label {
    @apply text-medium font-normal leading-22 text-theme-black-850;
  }
}

::v-deep .el-switch__core {
  @apply w-8;
}

::v-deep .el-table__header .el-table__cell {
  @apply text-theme-text-gray font-normal leading-3 font-medium opacity-65;
}

.el-table ::v-deep .el-table__expand-icon--expanded,
.el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

/*有子节点 且未展开*/
.el-table ::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
  background: url('/entrance/img/right.png') no-repeat;
  content: '';
  @apply block w-3 h-3 text-small bg-auto;
}

/*有子节点 且已展开*/
.el-table ::v-deep .el-table__expand-icon--expanded .el-icon-arrow-right:before {
  background: url('/entrance/img/right.png') no-repeat;
  content: '';
  @apply block w-3 h-3 text-small bg-auto;
}

/* 拖拽列表时给拖拽行添加背景色，以便后期修改 */
/* .sortable-chosen {
  @apply bg-theme ;
} */
</style>
